import React from 'react';
import { Handle, Position } from 'reactflow';
import { Diamond } from 'lucide-react';
import './NodeStyles.css';
import { useDesignerDerived } from '../../DesignerDerivedContext';

const MAX_BODY_CHARS = 28;

const DecisionNode = ({ id, data, selected }) => {
    const { decisionPredicates } = useDesignerDerived();
    const ctxPredicate = decisionPredicates.get(id);
    const raw = ctxPredicate || data.text || data.label || 'Decision?';
    const predicate = String(raw).endsWith('?') ? String(raw) : `${raw}?`;
    const truncated = predicate.length > MAX_BODY_CHARS;
    const display = truncated ? `${predicate.slice(0, MAX_BODY_CHARS - 1)}…` : predicate;
    const title = [truncated ? predicate : null, data.wfTooltip].filter(Boolean).join('\n');

    return (
        <div className={`decision-node ${selected ? 'selected' : ''}`} title={title || undefined}>
            <Handle
                type="target"
                position={Position.Top}
                className="node-handle node-handle-top"
            />

            {/* Outer diamond = border, inner diamond = fill with header/body split */}
            <div className="decision-diamond-border">
                <div className="decision-diamond-fill">
                    <div className="decision-content">
                        <div className="decision-header">
                            <span className="decision-icon"><Diamond size={18} /></span>
                            <span className="decision-id" style={{ fontSize: 'calc(var(--node-title-font-size, 13px) * 1.3)' }}>{data.id || 'D?'}</span>
                        </div>
                        <div className="decision-body">
                            <div className="decision-label">
                                {display}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Handle
                type="source"
                position={Position.Bottom}
                className="node-handle node-handle-bottom"
            />
        </div>
    );
};

export default DecisionNode;
